package com.anjuros.website.templates.template1.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosIcon
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.template1.components.Template1SectionTitle
import com.anjuros.website.templates.template1.modules.Template1ProductFeature
import com.anjuros.website.templates.template1.modules.Template1Section
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.modules.getColor
import com.anjuros.website.templates.template1.util.ResKey
import com.anjuros.website.templates.template1.util.Template1ObserverViewportEntered
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times

@OptIn(DelicateApi::class)
@Composable
fun Template1About(){
    val breakpoint = rememberBreakpoint()
    Box(
        modifier = Modifier
            .id(Template1Section.Service.id)
            .fillMaxSize(),
        contentAlignment = Alignment.Center
    ){
        AnjurosImage(
            src = "template1_about.jpg",
            modifier = Modifier.fillMaxWidth().displayIfAtLeast(Breakpoint.LG)
                .objectFit(ObjectFit.Cover),
            alt="Products I use"
        )
        AnjurosImage(
            src = "template1_about_mobile.jpg",
            modifier = Modifier.fillMaxSize().displayUntil(Breakpoint.LG)
                .objectFit(ObjectFit.Cover),
            alt="Products I use"
        )
        Template1ProductsContent(
            modifier = Modifier.align(if(breakpoint>= Breakpoint.LG) Alignment.CenterEnd else Alignment.Center)
                .padding(topBottom = if(breakpoint>= Breakpoint.LG) 0.px else 50.px)

        )
    }
}

@Composable
private fun Template1ProductsContent(
    modifier: Modifier
) {
    var opacity by remember { mutableStateOf(0.0f) }

    Template1ObserverViewportEntered(
        sectionId = "aboutItems",
        distanceFromTop = 600.0,
        onViewportEnteredLambda = {
          opacity = 1.0f
        }
    )
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {

        Template1SectionTitle(
            badge = ResKey.TEMPLATE1_INFO_DESC,
            title = ResKey.TEMPLATE1_ABOUT_TITLE,
            text = ResKey.TEMPLATE1_ABOUT_PARAGRAPH
        )



        SimpleGrid(
            modifier = Modifier
                .fillMaxWidth()
                .id("aboutItems")
                .margin(top=45.px),
           numColumns = numColumns(base = 2,lg=4)
        ) {

            Template1ProductFeature.entries.forEach { feature ->

                Template1ProductFeatureItem(
                    feature = feature,
                    opacity = opacity
                )
            }
        }
    }
}


@Composable
private fun Template1ProductFeatureItem(
    feature: Template1ProductFeature,
    opacity:Float
) {

    Column(
        modifier = Modifier
            .width(170.px)
            .opacity(opacity)
            .transition(Transition.of(
                "opacity",
                1200.ms,
                delay=700.ms*feature.ordinal
            ))
            .padding(leftRight = 8.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        AnjurosIcon(
            modifier = Modifier
                .size(48.px),
            src = feature.icon,
            alt = ""
        )



        SpanText(
            LocalText(feature.title),
            Modifier
                .fontSize(16.px)
                .margin (top=18.px)
                .fontWeight(FontWeight.SemiBold)
                .textAlign(TextAlign.Center)
                .color(
                    Template1Theme.Primary.getColor()
                )
        )


        SpanText(
            LocalText(feature.text),
            Modifier
                .fontSize(14.px)
                .margin(top=10.px)
                .lineHeight(22.px)
                .textAlign(TextAlign.Center)
                .color(
                    Template1Theme.Secondary.getColor()
                )
        )
    }
}